import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import programIcon1 from "../Asstes/Images/program-icon-1.svg";
import programIcon2 from "../Asstes/Images/program-icon-2.svg";
import programIcon3 from "../Asstes/Images/program-icon-3.svg";
import programIcon4 from "../Asstes/Images/program-icon-4.svg";
import programIcon5 from "../Asstes/Images/program-icon-5.svg";
import programIcon6 from "../Asstes/Images/program-icon-6.svg";
import config from "../config";

const RemoteProgram = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [banner, setBanner] = useState(null);
  const [content, setContent] = useState(null);
  const [whyGoRemote, setWhyGoRemote] = useState(null);
  const [finalCTA, setFinalCTA] = useState(null);
  const [faqs, setFaqs] = useState([]);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    // Fetch banner
    axios
      .get(`${config.API_BASE_URL}/banners/jobseekers-remote-program`)
      .then((res) => {
        if (res.data?.banners?.length > 0) {
          setBanner(res.data.banners[0]);
        }
      })
      .catch((err) => console.error("Error fetching banner:", err));

    // Fetch content
    axios
      .get(`${config.API_BASE_URL}/content/jobseekers-remote-program`)
      .then((res) => {
        if (res.data?.content?.length > 0) {
          const allContent = res.data.content;
          setContent(allContent[0]);
          setWhyGoRemote(allContent.find((item) => item.id === "76"));
          setFinalCTA(allContent.find((item) => item.id === "28"));
        }
      })
      .catch((err) => console.error("Error fetching content:", err));

    // Fetch FAQs dynamically for "jobseekers-remote-program"
    axios
      .get(`${config.API_BASE_URL}/content/faqs`)
      .then((res) => {
        if (res.data?.content?.length > 0) {
          const filtered = res.data.content
            .filter((item) => item.link_url === "jobseekers-remote-program")
            .sort((a, b) => Number(a.content_order) - Number(b.content_order))
            .map((item, index) => ({
              q: `${index + 1}. ${item.content_title}`,
              a: item.content_text.replace(/<\/?[^>]+(>|$)/g, ""),
            }));
          setFaqs(filtered);
        }
      })
      .catch((err) =>
        console.error("Error fetching jobseekers-remote-program FAQs:", err)
      );
  }, []);

  return (
    <>
      {/* Banner Section */}
      {banner && (
        <div className="hire-section">
          <div className="container">
            <div className="hire-banner">
              <div className="image-container">
                <div className="text-side about">
                  <div
                    dangerouslySetInnerHTML={{ __html: banner.content_text }}
                  />
                  <Link
                    //to={banner.link_url || "/openings"}
                    to="/openings"
                    className="cta-yellow"
                  >
                    FIND REMOTE JOBS →
                  </Link>
                </div>
                <div className="image-side-about">
                  <img
                    src={`/prosapiens-cms/public/${banner.banner_image}`}
                    alt={banner.banner_title}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Dynamic Second Section */}
      {content && (
        <section className="what-we-do">
          <div className="container">
            <div className="image-container">
              <div className="image-side">
                <img
                  src={`/prosapiens-cms/public/${content.content_image}`}
                  alt=""
                />
              </div>
              <div className="text-side">
                <div
                  dangerouslySetInnerHTML={{ __html: content.content_text }}
                />
                <Link
                  to={
                    content.link_url && content.link_url !== "0"
                      ? content.link_url
                      : "/openings"
                  }
                  className="cta-button"
                >
                  START YOUR APPLICATION →
                </Link>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* FAQ Section */}
      <div className="container">
        <div className="faq-wrapper">
          {/* <div className="faq-left">FAQ -</div> */}
          <div className="faq-right">
            <h2>FAQ</h2>
            {faqs.length > 0 ? (
              faqs.map((faq, idx) => (
                <div className="faq-item" key={idx}>
                  <div
                    className={`faq-question${
                      activeIndex === idx ? " active" : ""
                    }`}
                    onClick={() => toggleFAQ(idx)}
                  >
                    {faq.q}
                    <span className="faq-icon">
                      {activeIndex === idx ? "–" : "+"}
                    </span>
                  </div>
                  <div
                    className={`faq-answer${
                      activeIndex === idx ? " active" : ""
                    }`}
                  >
                    {faq.a}
                  </div>
                </div>
              ))
            ) : (
              <p>No FAQs found for this page.</p>
            )}
          </div>
        </div>
      </div>

      {/* Why Go Remote */}
      {whyGoRemote && (
        <div className="container">
          <div dangerouslySetInnerHTML={{ __html: whyGoRemote.content_text }} />
        </div>
      )}

      {/* Final CTA */}
      {finalCTA && (
        <div className="container">
          <div className="hire-box">
            <div dangerouslySetInnerHTML={{ __html: finalCTA.content_text }} />
            <Link
              to={
                finalCTA.link_url && finalCTA.link_url !== "0"
                  ? finalCTA.link_url
                  : "/openings"
              }
              className="cta-yellow"
            >
              APPLY FOR REMOTE JOBS NOW →
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default RemoteProgram;
